<template>
  <div class="discography-view container">
    <header class="discography-header">
      <div>
        <h1 class="discography-title">
          Discography
        </h1>
        <p class="discography-subtitle">
          Albums, EPs, singles, and videos.
        </p>
      </div>
    </header>

    <section class="discography-list">
      <ReleaseCard
        v-for="release in releases"
        :key="release.id"
        :release="release"
      />
    </section>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import releasesData from '@/assets/discography.json'
import ReleaseCard from '@/components/cards/ReleaseCard.vue'
import { initFancyboxSizing } from '@/utils/initFancybox.js'

function parseDate(d) {
  if (!d) return 0
  const t = Date.parse(d)
  return isNaN(t) ? 0 : t
}

// Reverse chronological by releaseDate then year
const releases = releasesData.slice().sort((a, b) => {
  const da = parseDate(a.releaseDate)
  const db = parseDate(b.releaseDate)
  if (db !== da) return db - da
  return (b.year ?? 0) - (a.year ?? 0)
})
onMounted(() => {
  // Initialize Fancybox for video embeds
  setTimeout(() => {
    initFancyboxSizing()
  }, 100)
})
</script>

<style scoped>
.discography-view {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.discography-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
}

.discography-title {
  margin: 0;
}

.discography-subtitle {
  margin: 0.35rem 0 0;
  color: var(--secondary-color);
}

.discography-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
</style>
